import {
  usersTaxableLicensesSucceeded,
  usersTaxableLicensesStarted,
  usersTaxableLicensesFailure,
} from './dashboardSlice';

export const getUsersActionableTaxPaymentPeriodsAsync = () => {
  return async (dispatch, getState, api) => {
    dispatch(usersTaxableLicensesStarted());
    try {
      const response = await api.getTaxPaymentPeriods(getState());
      if (response.status === 200) {
        // filter result to only include actionable licenses (empty array if no match)
        const actionablePeriods = response?.data?.paymentPeriods?.filter(
          (period) => {
            period.licenses = period.licenses.filter(
              (license) => license.isActionable
            );
            return period.licenses.length > 0;
          }
        );

        dispatch(usersTaxableLicensesSucceeded(actionablePeriods));
      } else {
        dispatch(
          usersTaxableLicensesFailure(
            'Something went wrong while fetching taxable license periods.'
          )
        );
      }
    } catch (error) {
      dispatch(
        usersTaxableLicensesFailure(
          'Something went wrong while fetching taxable license periods.'
        )
      );
    }
  };
};
